module.exports = __webpack_public_path__ + "media/conmex/legislacion-e008d18e.png";